<template>
  <div class="tenancy-remarks__wrapper">
    <Collapse
      class="tenancy-remarks__collapse small title-font14 title-responsive"
      :title="$t('common.remarks')"
      :expand="true"
      :withBorder="false"
      :enableTransition="false"
      @expand-status="onExpand"
    >
      <template
        v-if="showPreview"
        slot="additional"
      >
        <a-row
          type="flex"
          class="tenancy-remarks__preview"
          align="bottom"
        >
          <a-col class="tenancy-remarks__comment">
            <pre v-html="previewRemark.comment" />
          </a-col>
          <a-col class="tenancy-remarks__hint">
            <HKLGrayHint>
              {{ previewRemark.confirmedByOn }}
            </HKLGrayHint>
          </a-col>
        </a-row>
      </template>
      <template slot="content">
        <a-row
          v-for="item in remarksList"
          :key="item.id"
          class="tenancy-remarks__item"
          type="flex"
          align="bottom"
        >
          <a-col
            class="tenancy-remarks__comment"
          >
            <pre v-html="item.comment" />
          </a-col>
          <a-col class="tenancy-remarks__hint">
            <HKLGrayHint>
              {{ item.confirmedByOn }}
            </HKLGrayHint>
          </a-col>
        </a-row>
      </template>
    </Collapse>
    <a-row
      v-if="hasUpdateRemarksAndDocsAccess"
      type="flex"
    >
      <a-col flex="1">
        <HKLForm ref="remarksForm">
          <HKLTextareaVue
            v-model="remarks"
            v-fusioninputcheck="{
              required: true
            }"
            class="tenancy-remarks__input"
          />
        </HKLForm>
      </a-col>
      <a-col>
        <HKLButton
          action="confirm"
          color="orange"
          @click="confirm"
        />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { updateTenancyRemarks } from '@/api/tenancies/request'
import HKLButton from '@/controls/Button/HKLButton.vue'
import Collapse from '@/controls/Collapse.vue'
import HKLForm from '@/controls/Form/HKLForm.vue'
import { useRefForm } from '@/controls/Form/hook'
import HKLGrayHint from '@/controls/HKLGrayHint.vue'
import HKLTextareaVue from '@/controls/Input/HKLTextarea.vue'
import { useRouteParamId } from '@/router/useRouter'
import { useStoreActions, useStoreGetters } from '@/store'
import dateUtil from '@/utils/dateUtil'
import i18n from '@/utils/i18n'
import { unref } from '@vue/composition-api'
import lodash from 'lodash'
import { computed, ref } from 'vue-demi'
import { useTenancyPermissions } from '../hook'

export default {
  components: {
    HKLForm,
    HKLGrayHint,
    HKLButton,
    HKLTextareaVue,
    Collapse,
  },
  setup () {
    const tenancyId = useRouteParamId()
    const { currentTenancy } = useStoreGetters('ccd', ['currentTenancy'])
    const { loadTenancy } = useStoreActions('ccd', ['loadTenancy'])
    const { hasUpdateRemarksAndDocsAccess } = useTenancyPermissions()
    const remarksList = computed(() => {
      const result = (unref(currentTenancy).remarks || []).map(item => {
        return {
          comment: item.detail.comment,
          confirmedByOn: i18n.t('confirmedBy', [item.who.displayName, dateUtil.formatByLongDate(item.createdAt, 'lll')]),
          createdAt: item.createdAt,
        }
      })
      return lodash.orderBy(result, 'createdAt').reverse()
    })
    const previewRemark = computed(() => {
      return unref(remarksList)[0] || {}
    })
    const { form: remarksForm, validate } = useRefForm()
    const remarks = ref()
    const showPreview = ref(false)
    function onExpand (_, isExpanded) {
      showPreview.value = !isExpanded
    }
    async function confirm () {
      if (!validate()) return
      const tid = unref(tenancyId)
      await updateTenancyRemarks(tid, { remarks: unref(remarks) })
      await loadTenancy(tid)
      remarks.value = ''
    }
    return {
      hasUpdateRemarksAndDocsAccess,
      onExpand,
      confirm,
      remarksForm,
      showPreview,
      previewRemark,
      remarksList,
      remarks,
    }
  },
}
</script>

<style lang="scss" scoped>
.tenancy-remarks {
  &__preview {
    margin-bottom: 5px;
  }
  &__item {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 5px;
    }
  }
  &__comment {
    flex-grow: 1;
    flex-shrink: 0;
    width: 100%;
  }
  &__hint {
    flex-grow: 0;
    flex-shrink: 1;
    text-align: right;
  }
  &__input {
    margin-right: 10px;
  }
}
</style>
